"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeaderCell = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _SortableTableHeaderCell = require("./SortableTableHeaderCell.js");
var _TableHeaderCell = require("./TableHeaderCell.js");
var _index = require("../../styles/index.js");
var _excluded = ["align", "scope", "isHover", "active", "selectable"];
/**
 * Use a TableHeaderCell in table's header row to label columns or indicate sorting.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tableheadercell--docs) |
 * [Encore site](https://encore.spotify.net/web/components/table#header-cell) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TableHeaderCell) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=20339-15552&t=s9ZDoQC7G8x5OYjx-1)
 */
var TableHeaderCell = exports.TableHeaderCell = function TableHeaderCell(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? 'col' : _ref$scope,
    isHover = _ref.isHover,
    active = _ref.active,
    selectable = _ref.selectable,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (props.sortable) {
    return /*#__PURE__*/_react["default"].createElement(_SortableTableHeaderCell.SortableTableHeaderCell, Object.assign({
      align: align,
      scope: scope
    }, props, {
      isHover: isHover,
      className: (0, _classnames["default"])((0, _index.textClass)('bodySmallBold'), props.className),
      "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.TableHeaderCell
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_TableHeaderCell.TableHeaderCellElement, Object.assign({
    $align: align,
    $active: active,
    scope: scope
  }, props, {
    $isHover: isHover,
    $selectable: selectable,
    className: (0, _classnames["default"])((0, _index.textClass)('bodySmallBold'), props.className),
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.TableHeaderCell
  }));
};